import React, { useContext } from "react";
import { Box, Button, IconButton, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import Text from "../../../../shared/components/Text";
import MainButton from "../../../../shared/components/MainButton";

export default function SlideController({
  currentStep,
  goToNextStep,
  goToPrevStep,
  sliderCollection,
  sliderStepsComponents,
  ...props
}) {
  const { palette } = useTheme();

  const { dispatch } = useContext(ProcessContext);

  const navigateToNextStep = () => {
    dispatch({
      type: "SET_FLOW_ITEM_OK",
    });
  };

  const sliderSteps = Object.keys(sliderCollection).map((s) => parseInt(s));
  const lastStep = sliderSteps[sliderSteps.length - 1];
  const disableFixedHeightBox = sliderStepsComponents[
    sliderCollection[currentStep]
  ].disableBox
    ? true
    : false;

  const isSliderStepperNeeded = sliderSteps.length > 1;

  return (
    <Box>
      {!disableFixedHeightBox && <Box height={"100px"} />}
      {isSliderStepperNeeded ? (
        <Box
          position={"relative"}
          bottom={"2rem"}
          width={"100%"}
          left={0}
          justifyContent="center"
          {...props}
        >
          <Box
            p={1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            boxShadow={5}
            borderRadius="500px"
            width="90%"
            maxWidth={320}
            margin={"auto"}
            bgcolor="white"
          >
            <IconButton onClick={goToPrevStep} disabled={currentStep === 0}>
              <i className="material-icons">chevron_left</i>
            </IconButton>
            <Box display="flex" alignItems="center" flexDirection="column">
              <Button onClick={navigateToNextStep}>
                <Typography
                  variant="subtitle2"
                  style={{ color: palette.text.title }}
                >
                  <Text tId={currentStep === lastStep ? "START" : "SKIP"} />
                </Typography>
              </Button>
              <Box display="flex" justifyContent="center" alignContent="center">
                {sliderSteps.map((_, i) => (
                  <Box
                    key={i}
                    bgcolor={
                      currentStep === i
                        ? palette.primary.main
                        : palette.grey[500]
                    }
                    borderRadius="100%"
                    width="10px"
                    height="10px"
                    style={{ margin: "0 0.25rem" }}
                  />
                ))}
              </Box>
            </Box>
            <IconButton
              onClick={goToNextStep}
              disabled={currentStep === lastStep}
            >
              <i className="material-icons">chevron_right</i>
            </IconButton>
          </Box>
        </Box>
      ) : (
        <Box width={"100%"}>
          <MainButton onClick={navigateToNextStep}>
            <Text tId={"START"} />
          </MainButton>
        </Box>
      )}
    </Box>
  );
}
